import { Spin } from 'antd';
import { useRouter } from 'next/router';
import { PropsWithChildren, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function RouteChangeSpinner({ children }: PropsWithChildren) {
    const { events } = useRouter();
    const { ready } = useTranslation();

    const [spinning, setSpinning] = useState(false);
    useEffect(() => {
        const handleRouteChangeStart = () => {
            setSpinning(true);
        };
        const handleRouteChangeEnd = () => {
            setSpinning(false);
        };

        events.on('routeChangeStart', handleRouteChangeStart);
        events.on('routeChangeComplete', handleRouteChangeEnd);
        events.on('routeChangeError', handleRouteChangeEnd);

        // If the component is unmounted, unsubscribe
        // from the event with the `off` method:
        return () => {
            events.off('routeChangeStart', handleRouteChangeStart);
            events.off('routeChangeComplete', handleRouteChangeEnd);
            events.off('routeChangeError', handleRouteChangeEnd);
        };
    }, [events]);

    return (
        // @delay: see https://4x.ant.design/components/spin/#API
        <Spin className="route-change-loading" delay={500} size="large" spinning={spinning || !ready}>
            {children}
        </Spin>
    );
}
